class AvailabilityListController {

    constructor($scope, $state, availabilityModelService, messageService, access, integrationService) {
        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
        this.access = access;
        this.integrationService = integrationService;
    }

    $onInit () {
        this.activeTab = 'exclusion';
        this.sort_start = false;
        this.sort_end = false;

        this.updatePaging();
        this.$scope.$watch(
            function (scope) {
                return scope.current_page;
            },
            function (newVal, oldVal, scope) {
                if (newVal && newVal !== oldVal) {
                    scope.$ctrl[scope.$ctrl.activeTab] = undefined;
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        let filter = {};
                        filter[scope.$ctrl.filtertype] = scope.$ctrl.filtertext;
                        filter.page = newVal;
                        filter.perpage = scope.$ctrl.per_page;
                        filter.ruletype = scope.$ctrl.activeTab;

                        filter = scope.$ctrl.sortFilter(filter);

                        scope.$ctrl.availabilityModelService.search(filter).then(response => {
                            scope.$ctrl[scope.$ctrl.activeTab] = response;
                            scope.$ctrl.loading = false;
                        });
                    }
                    else {
                        let filter = {};
                        filter.page = newVal;
                        filter.perpage = scope.per_page;
                        filter.ruletype = scope.$ctrl.activeTab;

                        filter = scope.$ctrl.sortFilter(filter);

                        scope.$ctrl.availabilityModelService.findAll(filter)
                            .then(list => scope.$ctrl[scope.$ctrl.activeTab] = list);
                    }
                }
            }
        );
    }

    updatePaging () {
        this.$scope.per_page = this[this.activeTab].per_page;
        this.$scope.current_page = this[this.activeTab].current_page;
        this.$scope.total = this[this.activeTab].total;
    }

    onDelete (availability, type) {
        this.availabilityModelService.delete(availability.id, {
            ruletype: type
        })
            .then(() => {
                this.messageService.success(`The availability <strong>${availability.human_start}</strong> to <strong>${availability.human_end}</strong> was successfully deleted.`);
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The availability <strong>${availability.human_start}</strong> to <strong>${availability.human_end}</strong> could not be successfully deleted: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                return this.reloadList();
            });
    }

    reloadList () {
        let filter = {};
        filter.page = this[this.activeTab].current_page;
        filter.perpage = this[this.activeTab].per_page;
        filter.ruletype = this.activeTab;

        filter = this.sortFilter(filter);

        this[this.activeTab] = [];
        this.loading = true;
        return this.availabilityModelService.findAll(filter).then(response => {
            this[this.activeTab] = response;
            this.loading = false;
        });
    }

    filter () {
        if (!this.loading) {
            let filter = {};
            if (this.filtertype) {
                let filtertext = this.filtertext;
                if (this.filtertype === 'time') {
                    if (this.filtertext) {
                        filtertext = filtertext.format('YYYY-MM-DD HH:mm:00');
                    }
                }
                filter[this.filtertype] = filtertext;
            }
            filter.page = this.$scope.page;
            filter.perpage = this.$scope.per_page;
            filter.ruletype = this.activeTab;

            filter = this.sortFilter(filter);

            this.startFilter();
            this.availabilityModelService.search(filter).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        if (this.isFiltered) {
            this.startFilter();
            this.sort_start = false;
            this.sort_end = false;
            this.availabilityModelService.findAll({
                ruletype: this.activeTab
            }).then(response => {
                this.isFiltered = false;
                this.endFilter(response);
            });
        }
    }

    filtertypeChange () {
        switch (this.filtertype) {
            default:
                this.filtertext = '';
                break;
            case 'status':
                this.filtertext = '1';
                break;
        }
    }

    startFilter () {
        this[this.activeTab] = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this[this.activeTab] = response;
        this.updatePaging();
        this.loading = false;
    }

    sort (type) {
        switch (type) {
            case 'start':
                this.sort_end = false;
                if (!this.sort_start || this.sort_start === 'asc') {
                    this.sort_start = 'desc';
                } else {
                    this.sort_start = 'asc';
                }
                break;

            case 'end':
                this.sort_start = false;
                if (!this.sort_end || this.sort_end === 'asc') {
                    this.sort_end = 'desc';
                } else {
                    this.sort_end = 'asc';
                }
                break;
        }

        this.filter();
    }

    sortFilter (filter) {
        if (this.sort_start) {
            filter.order_by = 'start';
            filter.direction = this.sort_start;
        } else if (this.sort_end) {
            filter.order_by = 'end';
            filter.direction = this.sort_end;
        }
        return filter;
    }

    hasIntegration () {
        return this.integrationService.hasIntegration();
    }

    availabilityTypes () {
        let types = ['exclusion'];

        if (!this.hasIntegration()) {
            types.push('inclusion');
        }

        return types;
    }
}

AvailabilityListController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService', 'access', 'integrationService'];

export default AvailabilityListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/controllers/availability.list.controller.js